namespace RioERP.Products {
    export interface ProductsForm {
        ProductName: Serenity.StringEditor;
        Description: Serenity.TextAreaEditor;
        WebsiteUrl: Serenity.StringEditor;
        EProductType: Serenity.EnumEditor;
        SkuCode: Serenity.StringEditor;
        TemplateSerialKeyId: Serenity.IntegerEditor;
        ProductCategList: Serenity.LookupEditor;
        ERioplayVersion: Serenity.EnumEditor;
        RioplayProductCode: Serenity.StringEditor;
        ProductIds: Serenity.StringEditor;
        GrossAmount: Serenity.DecimalEditor;
        TeacherName: Serenity.StringEditor;
        DownloadUrl1: Serenity.StringEditor;
        DownloadUrl2: Serenity.StringEditor;
        HasPenDrive: Serenity.BooleanEditor;
        HasBooks: Serenity.BooleanEditor;
        HasCourier: Serenity.BooleanEditor;
        IsLive: Serenity.BooleanEditor;
        InAppDownload: Serenity.BooleanEditor;
        HasVod: Serenity.BooleanEditor;
        ProcesOrderOnPaid: Serenity.BooleanEditor;
        IsCombo: Serenity.BooleanEditor;
        ComboProductId: Serenity.LookupEditor;
        Weight: Serenity.DecimalEditor;
        Height: Serenity.DecimalEditor;
        Width: Serenity.DecimalEditor;
        Length: Serenity.DecimalEditor;
        EPackingType: Serenity.EnumEditor;
        Note: Serenity.StringEditor;
        EShippedby: Serenity.EnumEditor;
        VendorId: Serenity.LookupEditor;
        SupportInfo: Serenity.HtmlContentEditor;
        ProductQueryInfo: Serenity.HtmlContentEditor;
        EOpens: Serenity.EnumEditor;
        EWatchTime: Serenity.EnumEditor;
        EValidityType: Serenity.EnumEditor;
        EValidity: Serenity.EnumEditor;
        ValidTill: Serenity.DateEditor;
        TotalAllowedDuration: Serenity.IntegerEditor;
        EAccessStatus: Serenity.EnumEditor;
        AllowSerialKeyGeneration: Serenity.BooleanEditor;
        ActivateSerialKey: Serenity.BooleanEditor;
        AllowedDevice: Serenity.LookupEditor;
        RioPlayTenantId: Serenity.IntegerEditor;
        Secretkey: Serenity.StringEditor;
    }

    export class ProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Products.Products';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductsForm.init)  {
                ProductsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.TextAreaEditor;
                var w2 = s.EnumEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.LookupEditor;
                var w5 = s.DecimalEditor;
                var w6 = s.BooleanEditor;
                var w7 = s.HtmlContentEditor;
                var w8 = s.DateEditor;

                Q.initFormType(ProductsForm, [
                    'ProductName', w0,
                    'Description', w1,
                    'WebsiteUrl', w0,
                    'EProductType', w2,
                    'SkuCode', w0,
                    'TemplateSerialKeyId', w3,
                    'ProductCategList', w4,
                    'ERioplayVersion', w2,
                    'RioplayProductCode', w0,
                    'ProductIds', w0,
                    'GrossAmount', w5,
                    'TeacherName', w0,
                    'DownloadUrl1', w0,
                    'DownloadUrl2', w0,
                    'HasPenDrive', w6,
                    'HasBooks', w6,
                    'HasCourier', w6,
                    'IsLive', w6,
                    'InAppDownload', w6,
                    'HasVod', w6,
                    'ProcesOrderOnPaid', w6,
                    'IsCombo', w6,
                    'ComboProductId', w4,
                    'Weight', w5,
                    'Height', w5,
                    'Width', w5,
                    'Length', w5,
                    'EPackingType', w2,
                    'Note', w0,
                    'EShippedby', w2,
                    'VendorId', w4,
                    'SupportInfo', w7,
                    'ProductQueryInfo', w7,
                    'EOpens', w2,
                    'EWatchTime', w2,
                    'EValidityType', w2,
                    'EValidity', w2,
                    'ValidTill', w8,
                    'TotalAllowedDuration', w3,
                    'EAccessStatus', w2,
                    'AllowSerialKeyGeneration', w6,
                    'ActivateSerialKey', w6,
                    'AllowedDevice', w4,
                    'RioPlayTenantId', w3,
                    'Secretkey', w0
                ]);
            }
        }
    }
}
